// Role badges shown in admin screens. 管理者 covers both admin and super_admin:
// the distinction does not matter when you are looking at whose data this is.
export const roleLabel = (role?: string): string => {
  switch (role) {
    case 'student':
      return '生徒'
    case 'teacher':
      return '先生'
    case 'admin':
    case 'super_admin':
      return '管理者'
    default:
      return role ?? '不明'
  }
}

export const roleColor = (role?: string): string => {
  switch (role) {
    case 'teacher':
      return 'bg-indigo-100 text-indigo-800'
    case 'admin':
    case 'super_admin':
      return 'bg-purple-100 text-purple-800'
    default:
      return 'bg-gray-100 text-gray-700'
  }
}
